import { Action } from 'redux';
import {IWebhook} from '../../models';

// Types

export enum WebhookActionTypes {
  LOAD_WEBHOOK = 'webhook/load',
  LOADING_WEBHOOK = 'webhook/loading',
  LOADED_WEBHOOK = 'webhook/loaded',
  LOADING_WEBHOOK_FAILED = 'webhook/loading_failed',

  CREATE_WEBHOOK = 'webhook/create',
  CREATING_WEBHOOK = 'webhook/creating',
  CREATED_WEBHOOK = 'webhook/created',
  CREATING_WEBHOOK_FAILED = 'webhook/creating_failed',

  UPDATE_WEBHOOK = 'webhook/update',
  UPDATING_WEBHOOK = 'webhook/updating',
  UPDATED_WEBHOOK = 'webhook/updated',
  UPDATING_WEBHOOK_FAILED = 'webhook/updating_failed',

  DELETE_WEBHOOK = 'webhook/delete',
  DELETING_WEBHOOK = 'webhook/deleting',
  DELETED_WEBHOOK = 'webhook/deleted',
  DELETING_WEBHOOK_FAILED = 'webhook/deleting_failed',

  UNSET_WEBHOOKS = 'webhook/unset',
}

// Interfaces

export interface ILoadWebhookAction extends Action {
  type: WebhookActionTypes.LOAD_WEBHOOK;
}

export interface ILoadingWebhookAction extends Action {
  type: WebhookActionTypes.LOADING_WEBHOOK;
}

export interface ILoadedWebhookAction extends Action {
  type: WebhookActionTypes.LOADED_WEBHOOK;
  payload: {
    webhook: IWebhook;
  }
}

export interface ILoadingWebhookFailedAction extends Action {
  type: WebhookActionTypes.LOADING_WEBHOOK_FAILED;
}

export interface ICreateWebhookAction extends Action {
  type: WebhookActionTypes.CREATE_WEBHOOK;
  payload: {
    webhook: IWebhook;
  }
}

export interface ICreatingWebhookAction extends Action {
  type: WebhookActionTypes.CREATING_WEBHOOK;
}

export interface ICreatedWebhookAction extends Action {
  type: WebhookActionTypes.CREATED_WEBHOOK;
  payload: {
    webhook: IWebhook;
  }
}

export interface ICreatingWebhookFailedAction extends Action {
  type: WebhookActionTypes.CREATING_WEBHOOK_FAILED;
}

export interface IUpdateWebhookAction extends Action {
  type: WebhookActionTypes.UPDATE_WEBHOOK;
  payload: {
    uid: string;
    webhook: Partial<IWebhook>;
  }
}

export interface IUpdatingWebhookAction extends Action {
  type: WebhookActionTypes.UPDATING_WEBHOOK;
}

export interface IUpdatedWebhookAction extends Action {
  type: WebhookActionTypes.UPDATED_WEBHOOK;
  payload: {
    webhook: IWebhook;
  }
}

export interface IUpdatingWebhookFailedAction extends Action {
  type: WebhookActionTypes.UPDATING_WEBHOOK_FAILED;
}

export interface IDeleteWebhookAction extends Action {
  type: WebhookActionTypes.DELETE_WEBHOOK;
  payload: string; // webhook uid or report uid?
}

export interface IDeletingWebhookAction extends Action {
  type: WebhookActionTypes.DELETING_WEBHOOK;
}

export interface IDeletedWebhookAction extends Action {
  type: WebhookActionTypes.DELETED_WEBHOOK;
}

export interface IDeletingWebhookFailedAction extends Action {
  type: WebhookActionTypes.DELETING_WEBHOOK_FAILED;
}

export interface UnsetWebhooksAction extends Action {
  type: WebhookActionTypes.UNSET_WEBHOOKS;
}

// Functions

export function loadWebhook(): ILoadWebhookAction {
  return {
    type: WebhookActionTypes.LOAD_WEBHOOK,
  };
}

export function loadingWebhook(): ILoadingWebhookAction {
  return {
    type: WebhookActionTypes.LOADING_WEBHOOK,
  };
}

export function loadedWebhook(webhook: IWebhook): ILoadedWebhookAction {
  return {
    type: WebhookActionTypes.LOADED_WEBHOOK,
    payload: {
      webhook,
    },
  };
}

export function loadingWebhookFailed(): ILoadingWebhookFailedAction {
  return {
    type: WebhookActionTypes.LOADING_WEBHOOK_FAILED,
  };
}

export function createWebhook(webhook: IWebhook): ICreateWebhookAction {
  return {
    type: WebhookActionTypes.CREATE_WEBHOOK,
    payload: {
      webhook,
    },
  };
}

export function creatingWebhook(): ICreatingWebhookAction {
  return {
    type: WebhookActionTypes.CREATING_WEBHOOK,
  };
}

export function createdWebhook(webhook: IWebhook): ICreatedWebhookAction {
  return {
    type: WebhookActionTypes.CREATED_WEBHOOK,
    payload: {
      webhook,
    }
  };
}

export function creatingWebhookFailed(): ICreatingWebhookFailedAction {
  return {
    type: WebhookActionTypes.CREATING_WEBHOOK_FAILED,
  };
}

export function updateWebhook(uid: string, webhook: Partial<IWebhook>): IUpdateWebhookAction {
  return {
    type: WebhookActionTypes.UPDATE_WEBHOOK,
    payload: {
      uid,
      webhook,
    },
  };
}

export function updatingWebhook(): IUpdatingWebhookAction {
  return {
    type: WebhookActionTypes.UPDATING_WEBHOOK,
  };
}

export function updatedWebhook(webhook: IWebhook): IUpdatedWebhookAction {
  return {
    type: WebhookActionTypes.UPDATED_WEBHOOK,
    payload: {
      webhook,
    }
  };
}

export function updatingWebhookFailed(): IUpdatingWebhookFailedAction {
  return {
    type: WebhookActionTypes.UPDATING_WEBHOOK_FAILED,
  };
}

export function deleteWebhook(webhookUid: string): IDeleteWebhookAction {
  return {
    type: WebhookActionTypes.DELETE_WEBHOOK,
    payload: webhookUid,
  };
}

export function deletingWebhook(): IDeletingWebhookAction {
  return {
    type: WebhookActionTypes.DELETING_WEBHOOK,
  };
}

export function deletedWebhook(): IDeletedWebhookAction {
  return {
    type: WebhookActionTypes.DELETED_WEBHOOK,
  };
}

export function deletingWebhookFailed(): IDeletingWebhookFailedAction {
  return {
    type: WebhookActionTypes.DELETING_WEBHOOK_FAILED,
  };
}

export function unsetWebhooks(): UnsetWebhooksAction {
  return {
    type: WebhookActionTypes.UNSET_WEBHOOKS,
  };
}

export type WebhookActions =
  | ILoadWebhookAction
  | ILoadingWebhookAction
  | ILoadedWebhookAction
  | ILoadingWebhookFailedAction
  | ICreateWebhookAction
  | ICreatingWebhookAction
  | ICreatedWebhookAction
  | ICreatingWebhookFailedAction
  | IUpdateWebhookAction
  | IUpdatingWebhookAction
  | IUpdatedWebhookAction
  | IUpdatingWebhookFailedAction
  | IDeleteWebhookAction
  | IDeletingWebhookAction
  | IDeletedWebhookAction
  | IDeletingWebhookFailedAction
  | UnsetWebhooksAction;
